import { Confirm } from "notiflix/build/notiflix-confirm-aio";

export async function ativarDialog(titulo, mensagem, textoOk, textoCancelar, callbackOk, callbackCancelar) {
    Confirm.show(titulo, mensagem, textoOk, textoCancelar, callbackOk, callbackCancelar);
}
